import React , {useState} from "react";
import {
  styled,
  FormControl,
  Select,
  MenuItem,
  Pagination,
  Box
} from "@mui/material";
import { format } from "date-fns";
import {
  DataGrid,
  useGridApiContext,
  gridPageCountSelector,
  GridPagination,
  useGridSelector,
  gridPageSelector,
  GridCellModes
} from "@mui/x-data-grid";
import CustomCheckbox from "../CustomCheckbox";
import _ from 'lodash';

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  fontFamily: [
    "Roboto",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "& .MuiDataGrid-main": {
    border: "1px solid var(--gray-4)",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "var(--gray-6)",
    boxShadow: "inset 0 -1px 0 0 var(--gray-4)",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    color: "var(--gray-2)",
    fontSize: 14,
    fontWeight: 600,
  },
  "& .MuiDataGrid-cellContent": {
    color: "var(--secondary)",
    fontSize: 15,
  },
  "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-footerContainer": {
    backgroundColor: "#fff",
    height: 64,
  },
}));

const PaginationContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: 15,
}));


const StyledPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiButtonBase-root": {
    color: "var(--gray-1)",
  },
}));

const EditableTable = ({rows ,
   columns ,
    tableRef ,
     mySaveOnServerFunction ,
     onSelectionChange,
     selectedRows,
    }) => {
  
  const [cellModesModel, setCellModesModel] = React.useState({});

const handleCellClick = React.useCallback((params, event) => {

  if (!params.isEditable) {
    return;
  }

  // Ignore portal
  if (!event.currentTarget.contains(event.target)) {
    return;
  }

  setCellModesModel((prevModel) => {
    return {
      // Revert the mode of the other cells from other rows
      ...Object.keys(prevModel).reduce(
        (acc, id) => ({
          ...acc,
          [id]: Object.keys(prevModel[id]).reduce(
            (acc2, field) => ({
              ...acc2,
              [field]: { mode: GridCellModes.View },
            }),
            {},
          ),
        }),
        {},
      ),
      [params.id]: {
        // Revert the mode of other cells in the same row
        ...Object.keys(prevModel[params.id] || {}).reduce(
          (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
          {},
        ),
        [params.field]: { mode: GridCellModes.Edit },
      },
    };
  });
}, []);

const handleCellModesModelChange = React.useCallback((newModel) => {
  setCellModesModel(newModel);
}, []);


function PaginationEditTable({ page, onPageChange, className }) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <StyledPagination
    variant="outlined"
    shape="rounded"
    size="large"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
}

function CustomPagination(props) {
  return <GridPagination ActionsComponent={PaginationEditTable} {...props} />;
}

  const handleRowClassNames = (row) => {
      return Object.keys(row.row)?.some((key) => !row.row[key]?.valid || row.row[key]?.Returned)
    ? "datagrid-row highdanger"
    : "datagrid-row";
  };
  
return(
<>
<StyledDataGrid
        rows={rows}
        getRowId={(row) =>  `${row?.id.data}`}
        columns={columns}
        getRowClassName={handleRowClassNames}
        ref={tableRef}
        cellModesModel={cellModesModel}
        onCellModesModelChange={handleCellModesModelChange}
        onCellClick={handleCellClick}
        experimentalFeatures={{ newEditingApi: true }}
        processRowUpdate={(updatedRow, originalRow) =>
          mySaveOnServerFunction(updatedRow , originalRow)
        }
      
        components={{
          BaseCheckbox: CustomCheckbox,
          Pagination:CustomPagination
        }}
        //disableIgnoreModificationsIfProcessingProps 
        onSelectionModelChange={onSelectionChange}
        selectionModel={selectedRows}
        checkboxSelection
        hideFooterRowCount
        hideFooterSelectedRowCount
        disableSelectionOnClick
      />
</>
);

};

export default EditableTable;